import * as config from '../../helpers/config';
import { getCookie } from '../../helpers/cookies';

const errorMiddleware = () => (next) => (action) => {
  next(action);

  if (action.type.endsWith('_ERROR') && !action.meta?.ignoreError) {
    if (action.payload?.code === 401) {
      const idSiteCookie = getCookie('IdSite');

      // Redirect
      if (idSiteCookie === '22') {
        window.location.href = config.get('url.desk.signup');
      } else {
        window.location.href = config.get('url.team.signout');
      }
    } else {
      // TODO: we need something better here but at least we have something
      alert(`An error occured:\n${JSON.stringify(action, null, 2)}`);
    }
  }
};

export default errorMiddleware;
